import { Component, ChangeDetectionStrategy, OnInit } from "@angular/core";
import { AppLogger, Button } from "app-core";
import { Subject } from "rxjs";

import ButtonType = Data.Core.ButtonType;
import { Router } from "@angular/router";

interface ISubscription {
  planType: string;
  planDetails: string;
  validity: string;
  limit: string;
  freePlan: string | null;
  cost?: string;
}

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  viewProviders: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingComponent implements OnInit {
  public ngUnsubscribe = new Subject<void>();
  public selectPlanButton: Button = new Button({
    label: 'Select Plan',
    type: ButtonType.button,
    action: () => {
      this._route
        .navigate(['clinic/profile-list'], { queryParamsHandling: 'preserve' })
        .catch((err: string | Error) => AppLogger.Error(err));
    },
  });
  public planList: Array<ISubscription> = [];

  public constructor(
    private readonly _route: Router,
  ) {
  }

  public ngOnInit(): void {
    this.planList = [
      {
        freePlan: null,
        limit: 'Limit: 1 Doctor Profile / 1 Clinic Profile',
        planDetails: 'Explore all features',
        planType: 'Free',
        validity: 'Validity: 60 Days'
      },
      {
        freePlan: null,
        limit: 'Limit: 1 Doctor Profile / 1 Clinic Profile',
        planDetails: 'All features',
        planType: 'Basic 1 Month',
        validity: 'Validity: 30 Days',
        cost: 'Cost: 1000/- Rs. + GST'
      },
      {
        limit: 'Limit: 1 Doctor Profile / 1 Clinic Profile',
        planDetails: 'All features',
        planType: 'Basic 3 Months',
        validity: 'Validity: 90 Days',
        cost: 'Cost: 3000/- Rs. + GST',
        freePlan: 'Free: 7 Days additional validity'
      },
      {
        freePlan: 'Free: 15 Days additional validity',
        limit: 'Limit: 1 Doctor Profile / 1 Clinic Profile',
        planDetails: 'All features',
        planType: 'Basic 6 Months',
        validity: 'Validity: 180 Days',
        cost: 'Cost: 6000/- Rs. + GST'
      },
      {
        freePlan: 'Free: 30 Days additional validity',
        limit: 'Limit: 1 Doctor Profile / 1 Clinic Profile',
        planDetails: 'All features',
        planType: 'Basic 12 Months',
        validity: 'Validity: 365 Days',
        cost: 'Cost: 12,000/- Rs. + GST'
      },
    ];
  }
}
